import polyline from '@mapbox/polyline';
export const decodeCoordinates = (encodedString: string) => {
    if (encodedString !== null) {
        const coordinates = polyline.decode(encodedString)
        const realCoordinates = coordinates.map(([lat, lng]) => [lng, lat])
        if (
            realCoordinates[0][0] !== realCoordinates[realCoordinates.length - 1][0] ||
            realCoordinates[0][1] !== realCoordinates[realCoordinates.length - 1][1]
        ) {
            realCoordinates.push(realCoordinates[0]);
        }

        return [[realCoordinates]];
        // return [realCoordinates];
    } else {
        return []
    }

}
export const decodeCoordinatesList = (encodedStrings: string[]) => {

    const singolo = encodedStrings.map(encoded => {
        const decoded = polyline.decode(encoded);

        // Converti da [lat, lng] a [lng, lat]
        const formatted = decoded.map(([lat, lng]) => [lng, lat]); // <-- Qui mancava la parentesi chiusa

        // Verifica se il poligono è chiuso, altrimenti lo chiude
        if (
            formatted.length > 2 &&
            (formatted[0][0] !== formatted[formatted.length - 1][0] ||
                formatted[0][1] !== formatted[formatted.length - 1][1])
        ) {
            formatted.push([...formatted[0]]); // Chiudi il poligono
        }

        return formatted; // Un poligono in GeoJSON è [[]]
    });
    return [singolo]
}